import { HammerGestureConfig } from '@angular/platform-browser';
import * as i0 from "@angular/core";
export class HammerConfig extends HammerGestureConfig {
    buildHammer(element) {
        const mc = new Hammer(element, {
            touchAction: 'pan-y'
        });
        return mc;
    }
}
HammerConfig.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HammerConfig_Factory() { return new HammerConfig(); }, token: HammerConfig, providedIn: "root" });
